module.exports = __webpack_public_path__ + "static/media/shopping_memo.2e60acd9.gif";